import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Info } from "lucide-react";

export const Tooltip = ({ text }: { text: string }) => {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ x: 0, y: 0 });
  const iconRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (visible && iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setCoords({ x: rect.left + rect.width / 2, y: rect.top });
    }
  }, [visible]);

  return (
    <>
      <span
        ref={iconRef}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        className="inline-block ml-1 relative cursor-pointer"
      >
        <Info className="w-4 h-4 text-gray-400 hover:text-orange-500" />
      </span>

      {visible &&
        createPortal(
          <div
            className="fixed z-[9999] bg-black text-white text-xs px-2 py-1 rounded shadow-md whitespace-nowrap"
            style={{
              top: coords.y - 10,
              left: coords.x,
              transform: "translate(-50%, -100%)",
            }}
          >
            {text}
          </div>,
          document.body
        )}
    </>
  );
};
